@if (tour.active()) {
  <div
    class="tour-overlay"
    role="dialog"
    aria-modal="true"
    [attr.aria-label]="tour.currentStep()?.title || 'Průvodce'"
    [style.zIndex]="tour.getZIndex()"
  >
    <div
      class="tour-spotlight"
      [style.top.px]="spotlightTop()"
      [style.left.px]="spotlightLeft()"
      [style.width.px]="spotlightWidth()"
      [style.height.px]="spotlightHeight()"
      [style.--tour-backdrop-opacity]="tour.getBackdropOpacity()"
      aria-hidden="true"
    ></div>

    @if (popoverTop() !== null && popoverLeft() !== null) {
      <div
        class="tour-popover"
        [style.top.px]="popoverTop()!"
        [style.left.px]="popoverLeft()!"
        [style.maxWidth.px]="popoverMaxWidth()"
      >
        @if (tour.currentStep()?.title; as title) {
          <h3 class="tour-popover__title">{{ title }}</h3>
        }
        @if (tour.currentStep()?.content; as content) {
          <p class="tour-popover__content">{{ content }}</p>
        }

        <div class="tour-popover__footer">
          @if (tour.stepCount() > 1) {
            <span class="tour-popover__progress" aria-live="polite">
              {{ tour.currentIndex() + 1 }} / {{ tour.stepCount() }}
            </span>
          }
          <div class="tour-popover__actions">
            <button type="button" class="tour-popover__skip" (click)="skip()">
              Přeskočit
            </button>
            @if (!tour.isFirst()) {
              <button
                type="button"
                class="tour-popover__nav"
                (click)="tour.prev()"
              >
                Zpět
              </button>
            }
            <button
              type="button"
              class="tour-popover__primary"
              (click)="onPrimaryAction()"
            >
              {{ tour.isLast() ? 'Hotovo' : 'Další' }}
            </button>
          </div>
        </div>
      </div>
    }
  </div>
}
